import { useMatchMedia } from "@/hooks";

// https://www.radix-ui.com/colors
const AVATAR_COLORS: { light: string; dark: string }[] = [
    { light: "#8145b5", dark: "#48295c" }, // purple
    { light: "#0d74ce", dark: "#004074" }, // blue
    { light: "#2a7e3b", dark: "#25482d" }, // grass
    { light: "#cc4e00", dark: "#562800" }, // orange
    { light: "#107d98", dark: "#004558" }, // cyan
    { light: "#c2298a", dark: "#591c47" }, // pink
    { light: "#ab6400", dark: "#4d3000" }, // amber
    { light: "#008573", dark: "#084843" }, // teal
    { light: "#6550b9", dark: "#3c2e69" }, // violet
    { light: "#d13415", dark: "#5e1c16" }, // tomato
    { light: "#208368", dark: "#114837" }, // jade
    { light: "#3a5bc7", dark: "#253974" }, // indigo
];

// One color per email domain, assigned in the order access was first granted
const domainColorIndex = new Map<string, number>();

function domainOf(email: string): string {
    const at = email.lastIndexOf("@");
    return (at === -1 ? email : email.slice(at + 1)).toLowerCase();
}

function colorForDomain(domain: string): { light: string; dark: string } {
    let index = domainColorIndex.get(domain);
    if (index === undefined) {
        index = domainColorIndex.size % AVATAR_COLORS.length;
        domainColorIndex.set(domain, index);
    }
    return AVATAR_COLORS[index];
}

export function registerAvatarDomains(emails: string[]) {
    for (const email of emails) {
        colorForDomain(domainOf(email));
    }
}

export function MemberAvatar(props: { email: string; invited?: boolean; className?: string }) {
    const prefersDark = useMatchMedia("(prefers-color-scheme: dark)");
    const letter = props.email.charAt(0).toUpperCase();

    if (props.invited) {
        return (
            <div
                className={`border-1 flex h-6 w-6 flex-none items-center justify-center rounded-full border border-dashed border-gray-50 bg-gray-40 text-white dark:border-gray-60 dark:bg-gray-70 ${props.className ?? ""}`}
            >
                {letter}
            </div>
        );
    }

    const color = colorForDomain(domainOf(props.email));

    return (
        <div
            className={`flex h-6 w-6 flex-none items-center justify-center rounded-full text-white ${props.className ?? ""}`}
            style={{ backgroundColor: prefersDark ? color.dark : color.light }}
        >
            {letter}
        </div>
    );
}
